<template>
  <bita-modal
    :id="id"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />
            <bita-input
              type="text"
              name="slug"
              label="آدرس"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.slug"
            />
            <bita-texteditor
              name="content"
              ref="contentTextarea"
              label="محتوای صفحه"
              rules=""
              validation-container-class="col-lg-12"
              input-class="form-control"
              v-model="formData.content"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <div class="d-flex flex-column flex-md-row">
        <div class="col-12 col-md-2 mb-2 mb-md-0" v-if="!formData.id">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            icon="fas fa-save"
            class="w-100"
            @click.native="handleCreate"
          />
        </div>
        <div class="col-12 col-md-2" v-if="formData.id">
          <bita-bootbutton
            type="primary"
            title="به روزرسانی"
            icon="fas fa-save"
            class="w-100"
            @click.native="handleUpdate"
          />
        </div>
        <div class="col-12 col-md-1">
          <bita-bootbutton
            class="w-100 text-danger border-0 bg-transparent"
            type="danger"
            title="بستن"
            icon="fas fa-times"
            data-dismiss="modal"
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    isLoading: Boolean,
    title: String,
    id: String,
    propsData: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      formData: {},
      isLoadingModal: false,
    };
  },
  watch: {
    propsData: function(_val) {
      this.formData = _val;
      this.setInitialValue(_val.content);
    },
    isLoading: function(_val) {
      this.isLoadingModal = _val;
    },
  },
  methods: {
    setInitialValue(_data) {
      this.form = _data;
      this.$refs.contentTextarea.setInitialValue(_data ? _data : "");
    },
    handleCreate() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.formData);
        }
      });
    },
    handleUpdate() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", this.formData);
        }
      });
    },
    setErrors(err) {
      this.$refs.form.setErrors(err);
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>
